const COLORS = {
  red: "#FF0000",
  darkred: "#8B0000",
  white: "#fff",
  whitesmoke: "#f1f1f1",
  black: "#000000",
  beige: "#fbe4d5",
  darkgray: "#A9A9A9",
  blue: "#1da1f2",
  darkblue: "#0056b3",
  footer: "#212121",
};

export default COLORS;
